import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailOffice/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailOffice/video/sub/rtlsVideo3.mp4';

export default {
  banner: {
    title: 'Quản lý tài sản văn phòng',
    desc: 'Quản lý tài sản thiếu chuyên nghiệp gây ra tổn thất về thời gian và tài chính. Việc quản lý tài sản một cách rõ ràng và nhanh chóng giúp đảm bảo công việc không bị gián đoạn, góp phần vận hành doanh nghiệp trơn tru.',
  },

  video: {
    title: 'Quản lý tài sản chính xác hơn, an toàn hơn.',
    desc: 'Công nghệ theo dõi vị trí thời gian thực (RTLS) giúp theo dõi mọi thứ theo thời gian thực.<br/>Giải pháp này quản lý mọi tài sản trong văn phòng ở trạng thái tối ưu, cho phép vận hành với <strong>hiệu quả cao nhất.</strong>',
    play: video,
  },

  func: [
    {
      title: 'Theo dõi vị trí tài sản',
      desc: 'Xác định theo thời gian thực vị trí của các tài sản, bao gồm cả văn phòng phẩm cần thiết. Điều này giúp giảm thiểu sự di chuyển không cần thiết, thời gian lãng phí và chi phí, qua đó nâng cao hiệu quả vận hành văn phòng.',
      sub1: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      video: subVideo1,
    },
    {
      title: 'Quản lý kho hàng',
      desc: 'Nắm bắt chính xác số lượng kho hàng là yêu cầu cơ bản. Đồng thời, hệ thống xác định vị trí theo thời gian thực để biết rõ vật tư/văn phòng phẩm hiện đang ở đâu và số lượng là bao nhiêu.',
      sub1: 'Nắm bắt hiện trạng theo thời gian thực',
      icon1: IconClockGray,
      sub2: 'Kết nối dữ liệu nhanh chóng',
      icon2: IconShareGray,
      video: subVideo2,
    },
    {
      title: 'Thông báo khi tài sản được mang ra ngoài',
      desc: 'Theo dõi tự động việc mang ra ngoài các vật phẩm trong văn phòng, giảm thiểu tình trạng mất mát mà không cần tốn nhiều chi phí hay nhân lực.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên nền tảng đám mây',
      icon2: IconCloudCheckGray,
      video: subVideo3,
    },
  ],

  subfunc: {
    title: 'Tính năng đa dạng',
    desc: 'Giải pháp mang lại nhiều lợi ích như quản lý tồn kho hiệu quả, tiết kiệm thời gian và chi phí, tăng cường tính minh bạch và khả năng theo dõi.<br/>Orbro cung cấp những tính năng toàn diện để giúp xây dựng một môi trường làm việc lý tưởng và đạt hiệu suất tối đa.',
    data: [
      {
        icon: IconChartRadius,
        title: 'Báo cáo và phân tích',
        desc: 'Tạo báo cáo và tài liệu phân tích dựa trên lịch sử sử dụng tài sản. Nhờ đó, có thể đưa ra quyết định quản lý hiệu quả hơn.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo theo thời gian thực',
        desc: 'Khi phát hiện bất thường đối với một tài sản cụ thể, hệ thống sẽ gửi cảnh báo ngay lập tức để có thể xử lý kịp thời.',
      },
      {
        icon: IconRoute,
        title: 'Truy xuất lộ trình di chuyển của tài sản',
        desc: 'Theo dõi và lưu trữ dữ liệu về quá trình di chuyển của tài sản trong văn phòng. Điều này hỗ trợ việc phân tích hiệu suất sử dụng và ngăn ngừa thất thoát.',
      },
      {
        icon: IconDashboard,
        title: 'Nắm bắt hiện trạng',
        desc: 'Biết được chính xác tài sản đang ở đâu, đang được sử dụng hay đang di chuyển đến vị trí nào trong thời gian thực.',
      },
      {
        icon: IconWarning,
        title: 'Phát hiện rời khỏi khu vực',
        desc: 'Nếu một tài sản rời khỏi khu vực đã được thiết lập sẵn, hệ thống sẽ ngay lập tức gửi thông báo đến người quản lý.',
      },
      {
        icon: IconPenSquare,
        title: 'Quản lý số lượng',
        desc: 'Theo dõi số lượng tài sản còn lại. Nếu vượt mức quy định hoặc sắp hết, hệ thống sẽ phát cảnh báo để đảm bảo không bị gián đoạn hoạt động.',
      },
      {
        icon: IconChainLink,
        title: 'Tích hợp dữ liệu',
        desc: 'Kết nối hiệu quả với các hệ thống như RFID, IoT, an ninh và camera.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật dữ liệu',
        desc: 'Duy trì mức độ bảo mật dữ liệu cao, đảm bảo cung cấp giải pháp có độ tin cậy vượt trội.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'logisticsAsset' }, { data: 'manufacturingSteel' }, { data: 'blogOffice' }, { data: 'blogRTLS' }],
};
